import { useEffect, useRef } from 'react';
import * as d3 from 'd3';

export default function AnimatedBlob() {
  const svgRef = useRef(null);

  useEffect(() => {
    const svg = d3.select(svgRef.current);
    const size = 400;
    svg.attr('width', size).attr('height', size).attr('viewBox', `0 0 ${size} ${size}`);

    const numPoints = 6;
    const center = size / 2;
    const baseRadius = 120;

    // Create gradient
    const defs = svg.append('defs');
    const gradient = defs.append('radialGradient').attr('id', 'blobGradient');
    gradient.append('stop').attr('offset', '0%').attr('stop-color', '#818cf8').attr('stop-opacity', 0.4);
    gradient.append('stop').attr('offset', '50%').attr('stop-color', '#6366f1').attr('stop-opacity', 0.2);
    gradient.append('stop').attr('offset', '100%').attr('stop-color', '#22d3ee').attr('stop-opacity', 0.05);

    // Outer glow
    const filter = defs.append('filter').attr('id', 'blobGlow');
    filter.append('feGaussianBlur').attr('stdDeviation', '20').attr('result', 'coloredBlur');
    const feMerge = filter.append('feMerge');
    feMerge.append('feMergeNode').attr('in', 'coloredBlur');
    feMerge.append('feMergeNode').attr('in', 'SourceGraphic');

    const path = svg
      .append('path')
      .attr('fill', 'url(#blobGradient)')
      .attr('filter', 'url(#blobGlow)');

    // Second blob layer
    const gradient2 = defs.append('radialGradient').attr('id', 'blobGradient2');
    gradient2.append('stop').attr('offset', '0%').attr('stop-color', '#22d3ee').attr('stop-opacity', 0.3);
    gradient2.append('stop').attr('offset', '100%').attr('stop-color', '#818cf8').attr('stop-opacity', 0.02);

    const path2 = svg
      .append('path')
      .attr('fill', 'url(#blobGradient2)')
      .attr('filter', 'url(#blobGlow)');

    function generateBlob(time, offset = 0) {
      const points = [];
      for (let i = 0; i < numPoints; i++) {
        const angle = (i / numPoints) * Math.PI * 2;
        const wobble = Math.sin(time * 0.001 + i * 1.5 + offset) * 30 + Math.cos(time * 0.0007 + i * 2 + offset) * 20;
        const r = baseRadius + wobble;
        points.push([center + r * Math.cos(angle), center + r * Math.sin(angle)]);
      }
      points.push(points[0]);

      const lineGenerator = d3.line().curve(d3.curveBasisClosed);
      return lineGenerator(points);
    }

    let animFrame;
    function animate(time) {
      path.attr('d', generateBlob(time));
      path2.attr('d', generateBlob(time, 2));
      animFrame = requestAnimationFrame(animate);
    }
    animFrame = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animFrame);
  }, []);

  return (
    <svg ref={svgRef} className="absolute -left-20 top-1/2 -translate-y-1/2 opacity-60 pointer-events-none select-none" />
  );
}
